import $http from "../../axios";
import { Notification } from "element-ui";

const apiName = "/api/activos-fijos";
const routePathAdditions = "/api/activos-fijos-adiciones";
const routePathMonthlyDepreciation = "/api/activos-fijos-depreciacion-mensual";

export async function getLastConsecutiveSuggested({ commit, state }) {
  await $http
    .get("/api/activos-fijos-siguiente-consecutivo-sugerido")
    .then(response => {
      commit("setAttributeFixAsset", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function fetchFixAssets({ commit, state }) {
  await $http
    .get(apiName, {
      params: state.tableFixAssets.params
    })
    .then(response => {
      commit("setFixAssets", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("modelError", error.message);
    });
}

export async function fetchFixAssetById({ commit }, id) {
  await $http
    .get(`${apiName}/${id}`)
    .then(response => {
      commit("setFixAsset", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("modelError", error.message);
    });
}

export async function createFixAsset({ commit, state }) {
  commit("setErrorForm", false);

  await $http
    .post(apiName, state.fixAsset)
    .then(response => {
      commit("setFixAsset", response.data.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("setErrorForm", true);
    });
}

export async function updateFixAsset({ commit, state }) {
  commit("setErrorForm", false);

  await $http
    .put(`${apiName}/${state.fixAsset.id}`, state.fixAsset)
    .then(response => {
      commit("setFixAsset", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("setErrorForm", true);
    });
}

export async function partialUpdateFixAsset({ commit, state }, data) {
  commit("setErrorForm", false);

  await $http
    .put(`${apiName}/${state.fixAsset.id}`, data)
    .then(() => {
      Notification.success({
        title: "Exito!",
        message: 'Activo Fijo actualizado.',
        type: "success",
        duration: 1500,
        customClass: "notification-box"
      });
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("setErrorForm", true);
    });
}

export async function deleteFixAsset({ commit, dispatch, state }, id) {
  await $http
    .delete(`${apiName}/${id}`)
    .then(response => {
      dispatch("fetchFixAssets");
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("setErrorForm", true);
    });
}

export async function fetchCities({ commit, state }) {
  await $http
    .get("/api/ciudades")
    .then(response => {
      commit("setCities", response.data.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("modelError", error.message);
    });
}

function mapParameters(parameters) {
  return parameters.map(p => {
    return { value: p.id, label: p.name_parameter, code: p.code_parameter };
  });
}

export async function fetchActiveGroups({
  dispatch,
  rootState,
  commit,
  state
}) {
  if (state.activeGroups.length === 0) {
    await dispatch(
      "parameters/listParameter",
      { params: { codeParamTable: "C-015", paginate: false } },
      { root: true }
    );
    commit("setActiveGroups", mapParameters(rootState.parameters.parameters));
  }
}

export async function fetchClasses({ dispatch, rootState, commit, state }) {
  if (state.classes.length === 0) {
    await dispatch(
      "parameters/listParameter",
      { params: { codeParamTable: "C-016", paginate: false } },
      { root: true }
    );
    commit("setClasses", mapParameters(rootState.parameters.parameters));
  }
}

export async function fetchCostCenters({ dispatch, rootState, commit, state }) {
  if (state.costCenters.length === 0) {
    await dispatch(
      "parameters/listParameter",
      { params: { codeParamTable: "038", paginate: false } },
      { root: true }
    );
    commit("setCostCenters", mapParameters(rootState.parameters.parameters));
  }
}

export async function fetchDerecognizedTypes({
  dispatch,
  rootState,
  commit,
  state
}) {
  if (state.derecognizedTypes.length === 0) {
    await dispatch(
      "parameters/listParameter",
      { params: { codeParamTable: "C-017", paginate: false } },
      { root: true }
    );
    commit(
      "setDerecognizedTypes",
      mapParameters(rootState.parameters.parameters)
    );
  }
}

export async function fetchProviders({ dispatch, rootState, commit }, filter) {
  if (filter.length >= 3) {
    await dispatch(
      "contacts/listContact",
      {
        params: {
          type: "is_provider",
          filter
        }
      },
      {
        root: true
      }
    );
    commit("setProviders", rootState.contacts.contacts);
  }
}

export async function fetchMaintenanceProviders(
  { dispatch, rootState, commit },
  filter
) {
  if (filter.length >= 3) {
    await dispatch(
      "contacts/listContact",
      {
        params: {
          type: "is_provider",
          filter
        }
      },
      {
        root: true
      }
    );
    commit("setMaintenanceProviders", rootState.contacts.contacts);
  }
}

export async function fetchValuationsProviders(
  { dispatch, rootState, commit },
  filter
) {
  if (filter.length >= 3) {
    await dispatch(
      "contacts/listContact",
      {
        params: {
          type: "is_provider",
          filter
        }
      },
      {
        root: true
      }
    );
    commit("setValuationsProviders", rootState.contacts.contacts);
  }
}

export async function fetchPolicyProviders(
  { dispatch, rootState, commit },
  filter
) {
  if (filter.length >= 3) {
    await dispatch(
      "contacts/listContact",
      {
        params: {
          type: "is_provider",
          filter
        }
      },
      {
        root: true
      }
    );
    commit("setPolicyProviders", rootState.contacts.contacts);
  }
}

export async function fetchContactResponsibles(
  { dispatch, rootState, commit },
  filter
) {
  if (filter.length >= 3) {
    await dispatch(
      "contacts/listContact",
      {
        params: {
          type: "is_employee",
          filter
        }
      },
      {
        root: true
      }
    );
    commit("setContactResponsibles", rootState.contacts.contacts);
  }
}

export async function fetchContactsSale(
  { dispatch, rootState, commit },
  filter
) {
  if (filter.length >= 3) {
    await dispatch(
      "contacts/listContact",
      {
        params: {
          type: "is_customer",
          filter
        }
      },
      {
        root: true
      }
    );
    commit("setContactsSale", rootState.contacts.contacts);
  }
}

export async function downloadFixAssets({ state }) {
  await $http({
    url: "/api/activos-fijos-descargar",
    method: "GET",
    responseType: "blob"
  })
    .then(response => {
      const url = window.URL.createObjectURL(
        new Blob(["\ufeff", response.data])
      );
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute(
        "download",
        `Activos-Fijos-${new Date().toISOString().slice(0, 10)}.csv`
      );
      document.body.appendChild(link);
      link.click();
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: "Error al Descargar",
        type: "error",
        duration: 3000,
        customClass: "notification-box"
      });
    });
}

/**
 * Adiciones
 *
 * @author Kevin Galindo
 */
export async function fetchFixAssetAdditions({ commit, state }) {
  await $http
    .get(routePathAdditions, {
      params: state.tableFixAssetAdditions.params
    })
    .then(response => {
      commit("setFixAssetAdditions", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("modelError", error.message);
    });
}

export async function fetchFixAssetAdditionById({ commit }, id) {
  await $http
    .get(`${routePathAdditions}/${id}`)
    .then(response => {
      commit("setFixAssetAddition", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("modelError", error.message);
    });
}

export async function createFixAssetAddition({ dispatch, state }) {
  const data = {
    ...state.fixAssetAddition,
    fix_asset_id: state.fixAsset.id
  };

  await $http
    .post(routePathAdditions, data)
    .then(response => {
      dispatch("fetchFixAssetAdditions");
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function updateFixAssetAddition({ dispatch, state }) {
  const data = {
    ...state.fixAssetAddition,
    fix_asset_id: state.fixAsset.id
  };

  await $http
    .put(`${routePathAdditions}/${state.fixAssetAddition.id}`, data)
    .then(response => {
      dispatch("fetchFixAssetAdditions");
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function deleteFixAssetAddition({ commit, dispatch }, id) {
  await $http
    .delete(`${routePathAdditions}/${id}`)
    .then(() => {
      dispatch("fetchFixAssetAdditions");
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function fetchFixAssetMonthlyDepreciation({ commit }, id) {
  await $http
    .get(`${routePathMonthlyDepreciation}/${id}`)
    .then(response => {
      commit("setFixAssetMonthlyDepreciation", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.respons ? error.response.data : error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function fetchFixAssetDocumentDepreciation({ commit }) {
  await $http
    .get("/api/lista-comprobante-activos-fijos-depreciacion")
    .then(response => {
      commit("setFixAssetDocumentDepreciation", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.response ? error.response.data : error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });

      // throw Error(error);
    });
}

export async function regenerateFixAssetDocumentDepreciation(
  { commit, dispatch },
  document_id
) {
  commit("setTableFixAssetDocumentDepreciationLoading", true);

  await $http
    .post(
      `/api/regenerar-comprobante-activos-fijos-depreciacion/${document_id}`
    )
    .then(response => {
      Notification.success({
        title: "Exito!",
        message: "El documento se ha regenerado.",
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      dispatch("fetchFixAssetDocumentDepreciation");
    })
    .catch(error => {
      console.log(error.response);
      Notification.error({
        title: "Error!",
        message: error.response ? error.response.data.message : error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });

      // throw Error(error);
    });

  commit("setTableFixAssetDocumentDepreciationLoading", false);
}

export async function createFixAssetDocumentDepreciation(
  { commit, dispatch },
  yearMonth
) {
  commit("setTableFixAssetDocumentDepreciationLoading", true);
  await $http
    .post(`/api/comprobante-activos-fijos-depreciacion/${yearMonth}`)
    .then(response => {
      dispatch("fetchFixAssetDocumentDepreciation");
    })
    .catch(error => {
      console.log(error.response);
      Notification.error({
        title: "Error!",
        message: error.response ? error.response.data.message : error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });

      // throw Error(error);
    });
  commit("setTableFixAssetDocumentDepreciationLoading", false);
}

export async function createAndFetchFixAssetMonthlyDepreciation(
  { commit },
  id
) {
  await $http
    .post(`${routePathMonthlyDepreciation}/${id}`)
    .then(response => {
      commit("setFixAssetMonthlyDepreciation", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.response.data,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function generateExcelFixAssetDocumentDepreciation(
  { commit, dispatch },
  document_id
) {
  commit("setTableFixAssetDocumentDepreciationLoading", true);

  await $http
    .get(`/api/excel-comprobante-activos-fijos/${document_id}`)
    .then(response => {
      const { data, header, nameFile } = response.data;

      const array = typeof data !== "object" ? JSON.parse(data) : data;

      let str =
        `${Object.values(header)
          .map(value => `"${value}"`)
          .join(",")}` + "\r\n";

      let dataCsv = array.reduce((str, next) => {
        str +=
          `${Object.values(next)
            .map(value => `"${value}"`)
            .join(",")}` + "\r\n";
        return str;
      }, str);

      var hiddenElement = document.createElement("a");
      hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(dataCsv);
      hiddenElement.target = "_blank";
      hiddenElement.download = `${nameFile}.csv`;
      hiddenElement.click();
    })
    .catch(error => {
      console.log(error.response);
      Notification.error({
        title: "Error!",
        message: error.response ? error.response.data.message : error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });

      // throw Error(error);
    });

  commit("setTableFixAssetDocumentDepreciationLoading", false);
}

export async function fetchInspectionStatus({ commit }) {
  await $http.get(`/api/parametros-por-codigo/C-017`)
  .then((response) => {
    commit('setInspectionStatus', response.data.data)
  })
  .catch((error) => {

  })
}

export async function getTemplate({ dispatch }) {
  return await new Promise(async (resolve, reject) => {
    await $http
      .get('/api/activos-fijos-plantilla')
      .then((response) => {
        const csvContent = response.data.csv;

        const blob = new Blob(["\uFEFF" + csvContent], {
          type: "text/csv;charset=utf-8;",
        });

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "incorporar-activos-fijos.csv";
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        Notification.success({
          title: "¡Éxito!",
          message: "Plantilla descargada correctamente",
          type: "success",
          duration: 1500,
          customClass: "notification-box"
        });

        resolve();
      })
      .catch(() => {
        Notification.error({
          title: "Error",
          message: "No se pudo descargar la plantilla",
          type: "error",
          duration: 1500,
          customClass: "notification-box"
        });

        reject();
      });
  });
}


export async function getSubscriber({ commit }) {

    const subscriber = JSON.parse(localStorage.subscriber);
    const id = subscriber.id;
    
    await $http.get(`/api/suscriptores/${id}`)
    .then((response) => {
      commit('setSubscriber', response.data.data)
    })
    .catch((error) => {
      Notification.error({
        title: 'Error!',
        message: error.message,
        type: 'error',
        duration: 2000,
        customClass: 'notification-box',
      })
    })

}

export async function getDepreciationVoucherFixAssetsDocuments({ commit }) {

    const subscriber = JSON.parse(localStorage.subscriber);
    const id = subscriber.id;
    
    await $http.get(`/api/traer-comprobante-depreciacion-activos-fijos`)
    .then((response) => {
      commit('setDepreciationVoucherFixAssetsDocuments', response.data)
    })
    .catch((error) => {
      Notification.error({
        title: 'Error!',
        message: error.message,
        type: 'error',
        duration: 2000,
        customClass: 'notification-box',
      })
    })

}

export async function validateDepreciationVoucherFixAssets({ commit }) {    
    return await new Promise(async (resolve, reject) => {
      await $http.get(`/api/validar-activos-fijos-proceso-depreciacion`)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        Notification.error({
          title: 'Error!',
          message: error.message,
          type: 'error',
          duration: 2000,
          customClass: 'notification-box',
        })
        reject(error)

      })
    });
}

export async function depreciationVoucherFixAssets({ commit }, year_month) {    
    return await new Promise(async (resolve, reject) => {
      await $http.post(`/api/activos-fijos-proceso-depreciacion`, {year_month})
      .then((response) => {
        resolve(response.data)
        Notification.success({
          title: 'Exito!',
          message: 'Contabilizacion generada',
          type: 'success',
          duration: 2000,
          customClass: 'notification-box',
        })
      })
      .catch((error) => {
        Notification.error({
          title: 'Error!',
          message: error.message,
          type: 'error',
          duration: 2000,
          customClass: 'notification-box',
        })
        reject(error)

      })
    });
}

export async function fetchFixAssetsPPal({ commit, state }) {
  await $http
    .get(apiName, {
      params: {
        pagination: false
      }
    })
    .then(response => {
      commit("setFixAssetsPPal", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("modelError", error.message);
    });
}


function downloadCSV(data, filename = 'data.csv') {
  // Convertir cada fila en una cadena de texto CSV
  const csvContent = data.map(row => 
      row.map(item => `"${item}"`).join(';') // Separador de campos: ;
  ).join('\n'); // Unir las filas con saltos de línea

  // Crear un Blob con el contenido CSV
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  // Crear un enlace de descarga
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';

  // Agregar el enlace al documento y hacer clic para descargar
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export async function fetchVoucherDepreciationAssetsFixedAssetsExcel({ commit, state }, params) {
  await $http
    .get('/api/traer-comprobante-depreciacion-activos-fijos-excel', {
      params: {
        year_month: params.year_month
      }
    })
    .then(response => {

      const dataCsv = params.isNiif ? response.data.dataNiif : response.data.data;
      const pathName = params.isNiif ? `activos-deprec-niif-${params.year_month}` : `activos-deprec-fiscal-${params.year_month}`;
      
      downloadCSV(dataCsv, pathName)
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("modelError", error.message);
    });
}

export async function getHistoryDepreciation({ commit, state }) {
  await $http
    .get('/api/historico-depreciacion', {
      params: {
        fix_asset_id: state.fixAsset.id
      }
    })
    .then(response => {
      console.log('response.data.data :>> ', response.data);
      commit('setHistoryDepreciation', response.data)
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function incorporateFixedAssets({ dispatch }, formData) {

  return await new Promise(async (resolve, reject) => {
    await $http
    .post('/api/incorporar-activos-fijos', formData)
    .then(() => {
      Notification.success({
        title: "Exito!",
        message: 'Cargado con exito!',
        type: "success",
        duration: 1500,
        customClass: "notification-box"
      });
      resolve()
    })
    .catch(() => {
      Notification.error({
        title: "Error!",
        message: "Error al cargar el archivo",
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      reject()
    });
  });
}

export async function acquisitionFormSave({ dispatch }, data) {

  return await new Promise(async (resolve, reject) => {
    await $http
    .post('/api/acquisition-form-save', data)
    .then((response) => {
      Notification.success({
        title: "Exito!",
        message: 'Creado con exito!',
        type: "success",
        duration: 1500,
        customClass: "notification-box"
      });
      resolve(response.data.data)
    })
    .catch((error) => {
      const errorMessage = error.response && error.response.data && error.response.data.message 
        ? error.response.data.message 
        : "Error al crear";
      Notification.error({
        title: "Error!",
        message: errorMessage,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      reject(error)
    });
  });
}

export async function fetchVoucherTypes({ commit, state }, branchoffice) {
  await $http.get('/api/tipos-de-comprobantes', { 
    params: { 
      paginate: false,
      branchoffice: branchoffice
    } 
  })
    .then((response) => {
      commit('setVoucherTypes', response.data.data)
    })
    .catch((error) => {
      Notification.error({
        title: 'Error!',
        message: error.message,
        type: 'error',
        duration: 2000,
        customClass: 'notification-box',
      });
    })
}

export async function fetchContacts({ commit, state }) {
  await $http.get('/api/terceros', { params: state.paramsquery })
    .then((response) => {
      commit('setContacts', response.data.data.data)
    })
    .catch((error) => {
      Notification.error({
        title: 'Error!',
        message: error.message,
        type: 'error',
        duration: 1500,
        customClass: 'notification-box',
      });
    })
}


// WEBPACK FOOTER //
// ./src/modules/fixAssets/actions.js